module.exports = __webpack_public_path__ + "img/adminprogramme3.4a582e4b.png";